import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Container,
  FormControl,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Box,
  TextField,
  Stack,
  DialogTitle,
  Autocomplete,
  IconButton,
  Button,
  InputAdornment,
  Chip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { grey } from "@mui/material/colors";
import PinIcon from "@mui/icons-material/Pin";
import moment from "moment";
import Notify from "../../Notify";
import Alerta from "../../Alerta";
import CallIcon from "@mui/icons-material/Call";
import {getData, getCodeArg, postData} from "../../../services/library";
import { useLocation, useNavigate } from "react-router-dom";
import { empresasConfig } from '../../envasados/sucursalesMercadoLibre/config';

function Addchofer(props) {
   const navigate = useNavigate();
  const [datosFormulario, setDatosformulario] = useState({
    id_sisven: null,
    nombre_apellido: null,
    dni: null,
    legajo: null,
    nro_licencia: null,
    vencimiento_licencia: null,
    examen_carga: null,
    usuario: localStorage.getItem("user"),
    activo: 1,
    negocio: null,
    username: null,
    telefono: null,
    pto_vta_hipergas:"",
    pto_vta_autogas:"",
    fecvto_art: null,  
    fecvto_svo: null,  
    fecvto_remito: null,  
    fecvto_protcal: null,  
    fecvto_cursocp: null,  
    fecvto_psicof: null, 
    id_sucursal:null
  });

  // const [puntosVenta, setPuntosVenta] = useState() //
  const [uso, setUso] = useState(null);
  const [usuarios, setUsuarios] = useState(null);
  const [disBtn, setDisBtn] = useState(false);
  const [codArg, setCodArg] = useState("");
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
// estado para el error
   const [errorDni, setErrorDni] = useState("");
  const [ErrorNroLicencia, setErrorNroLicencia] = useState("");
  const [errorTerminal, setErrorTerminal] = useState("");
  const [ptosVtaHiper, setPtosVtaHiper]=useState();
  const [ptosVtaAuto, setPtosVtaAuto]=useState();
  const [sucursales, setSucursales] = useState([])
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [cajasMercadoPago, setCajasMercadoPago] = useState([]);
  const [cajaSeleccionada, setCajaSeleccionada] = useState(null);
  const [posnets, setPosnets] = useState([])
  const [posnetSeleccionado, setPosnetSeleccionado] = useState(null);
  const [cargandoCajas, setCargandoCajas] = useState(false);
 //para sabar desde donde se lo llama al coponente desde choferes o el boton de agregar chover en el formulario de vehiculos guillea
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const origen = params.get("origen"); // 👉 "vehiculos"

  useEffect(() => {
    getData("/desplegables/usoVehiculo", setUso);
    getData(
      "/choferes/xusernameypuesto/" + datosFormulario.username,
      setUsuarios
    );
    getCodeArg(setCodArg);
    getData("/puntos_venta/seleccionpuntohiper", setPtosVtaHiper)
    getData("/puntos_venta/seleccionpuntoauto", setPtosVtaAuto)
    getData("/sucursales/", setSucursales)
  }, []);

const cargarCajasPorSucursal = async (sucursalId) => {
  if (!sucursalId) {
    setCajasMercadoPago([]);
    return;
  }
  
  setCargandoCajas(true);
  try {
    const id = typeof sucursalId === 'object' ? sucursalId.id : sucursalId;
    
    const response = await fetch(`${UrlApi}/envasado_cajas_mercadolibre/xsucursalnetizar/${id}`);
    const data = await response.json();
    
    // console.log("DATA CAJAS (raw):", data);
    
    // Como ahora devuelve un array directamente
    const cajasArray = Array.isArray(data) ? data : (data.results || data.data || []);
    setCajasMercadoPago(cajasArray);
    
    console.log("Cajas procesadas:", cajasArray);
    
  } catch (error) {
    console.error('Error al cargar cajas:', error);
    setCajasMercadoPago([]);
  } finally {
    setCargandoCajas(false);
  }
};

const cargarPosnets = async (sucursal) => {
  let empresa = sucursal?.empresa || null;
  console.log("SUCURSAL", empresa);
  
  try {
    let url = empresa === 1 
      ? empresasConfig.hipergas.apiBaseUrl 
      : empresasConfig.naturalgas.apiBaseUrl;
    
    const response = await fetch(`${url}/api/qr/mp/terminals`);
    const data = await response.json();
    
    // Obtener los resultados (puede estar en results o data.terminals)
    let terminales = [];
    if (data.results) {
      terminales = data.results;
    } else if (data.data && data.data.terminals) {
      terminales = data.data.terminals;
    } else if (Array.isArray(data)) {
      terminales = data;
    }
    
    // FILTRAR SOLO LOS QUE ESTÁN EN MODO PDV
    const terminalesPDV = terminales.filter(t => t.operating_mode === "PDV");
    
    // Guardar en el estado posnets (ya existe)
    setPosnets(terminalesPDV);
    
    console.log("Terminales PDV:", terminalesPDV);
    
  } catch (error) {
    console.error('Error al cargar posnets:', error);
    setPosnets([]);
  }
};

  useEffect(() => {
  if (sucursalSeleccionada) {
    const sucursalId = sucursalSeleccionada.id || sucursalSeleccionada;
    if (sucursalId) {
      cargarCajasPorSucursal(sucursalId);
      cargarPosnets(sucursalSeleccionada);
    } else {
      setCajasMercadoPago([]);
      setCajaSeleccionada(null);
      setPosnets([]);
      setPosnetSeleccionado(null);
      setErrorTerminal(""); 
    }
  } else {
    setCajasMercadoPago([]);
    setCajaSeleccionada(null);
    setPosnets([]);
    setPosnetSeleccionado(null);
    setErrorTerminal(""); 
  }
}, [sucursalSeleccionada]);

  const almacenar = (e) => {
    setDatosformulario({
      ...datosFormulario,
      [e.target.name]: e.target.value === "" ? null : e.target.value,
    });
  };

  const handleClose = () => {
     if (origen === "vehiculos") {
      console.log("Cerrar y volver a Vehículos");
      setTimeout(() => {
    navigate("/vehiculos"); // vuelve a la ruta deseada
  }, 100); // breve delay para permitir el cambio
    } else {
      console.log("Cerrar normal");
      //original estan solo los   props.alta(false); props.tabla(true);
      props.alta(false);
      props.tabla(true);
      props.setActualizar(true)
    }
    
  };

  async function guardarChofer(e){
    setDisBtn(true)
    postData(e, "/choferes/postandupdate", {
      id_sisven: datosFormulario.id_sisven,
      id_sisven_autogas:datosFormulario.id_sisven_autogas,
      nombre_apellido: datosFormulario.nombre_apellido,
      dni: datosFormulario.dni,
      usuario: datosFormulario.usuario,
      activo: 1,
      legajo: datosFormulario.legajo,
      nro_licencia: datosFormulario.nro_licencia,
      vencimiento_licencia:
        datosFormulario.vencimiento_licencia !== ""
          ? datosFormulario.vencimiento_licencia
          : null,
      examen_carga:
        datosFormulario.examen_carga !== ""
          ? datosFormulario.examen_carga
          : null,
      negocio: datosFormulario.negocio,
      username: datosFormulario.username,
      telefono: datosFormulario.telefono
        ? codArg + datosFormulario.telefono
        : null,
      pto_vta_autogas: datosFormulario.pto_vta_autogas || null,
      pto_vta_hipergas: datosFormulario.pto_vta_hipergas || null,
       fecvto_art:datosFormulario.fecvto_art !== "" ? datosFormulario.fecvto_art : null,
       fecvto_svo:datosFormulario.fecvto_svo !== "" ? datosFormulario.fecvto_svo : null,
      //  fecvto_remito:datosFormulario.fecvto_remito !== "" ? datosFormulario.fecvto_remito : null,
      //  fecvto_protcal:datosFormulario.fecvto_protcal !== "" ? datosFormulario.fecvto_protcal : null,
       fecvto_cursocp:datosFormulario.fecvto_cursocp !== "" ? datosFormulario.fecvto_cursocp : null,
       fecvto_psicof:datosFormulario.fecvto_psicof !== "" ? datosFormulario.fecvto_psicof : null,
       id_sucursal:sucursalSeleccionada?.id??null,
       caja_mercadolibre:cajaSeleccionada?.external_id??null,
       posnet:posnetSeleccionado?.id??null
    }, setNotificacion);
  }

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";
  // Oculta el * del label aunque MUI lo marque como required
  const sinAsterisco = {
    "& .MuiFormLabel-asterisk": { display: "none" },
  };
  
//comento para subir
const validarCampo = async (campo, valor) => {
  try {
    let url = "";

    // Definir el endpoint según el campo
    switch(campo) {
      case "dni":
        url = `${UrlApi}/choferes/existedni/${valor}`;
        break;
      case "nro_licencia":
        url = `${UrlApi}/choferes/existenrolicencia/${valor}`;
        break;
      case "terminal":
        url = `${UrlApi}/choferes/terminalusada/${valor}`;
        break;
      default:
        return;
    }

    // Hacer la consulta al backend
    const res = await fetch(url);
    const data = await res.json();
    console.log("data", data);
    
    // Manejar los errores
    if (data.length > 0) {
      if (campo === "dni") setErrorDni("Ya existe un chofer con ese DNI");
      if (campo === "nro_licencia") setErrorNroLicencia("Ya existe un chofer con esa licencia");
      if (campo === "terminal") {
      const nombreChofer = data?.[0]?.nombre_apellido || "desconocido";
      setErrorTerminal(`Esta terminal ya está asignada al chofer: ${nombreChofer}`);
      }
    } else {
      if (campo === "dni") setErrorDni("");
      if (campo === "nro_licencia") setErrorNroLicencia("");
      if (campo === "terminal") setErrorTerminal("");
    }

  } catch (err) {
    console.error(`Error al verificar ${campo}:`, err);
    if (campo === "dni") setErrorDni("Error al validar DNI");
    if (campo === "nro_licencia") setErrorNroLicencia("Error al validar número de licencia");
    if (campo === "terminal") setErrorTerminal("Error al validar terminal");
  }
};
//agregue este efecto para manejar el   disabled={disBtn} del boton guardar
useEffect(() => {
  if (errorDni || ErrorNroLicencia || errorTerminal) {
    setDisBtn(true);
  } else {
    setDisBtn(false);
  }
}, [errorDni, ErrorNroLicencia, errorTerminal]);


  return (
    <div>
      {/* <br></br> */}
      <Container >
        <Box sx={{ flexGrow: 1, marginTop: 2 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
               Nuevo chofer
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <form onSubmit={guardarChofer} autoComplete="off">
          <Box
            backgroundColor="#F4F6F6"
            mt={2}
            p={3}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid container spacing={1} direction={{ xs: "column", sm: "row" }}>
              <Grid item xs={6}>
                <TextField
                  size={size}
                  placeholder="Nombre completo"
                  style={style}
                  focused
                  color="primary"
                  required
                  name="nombre_apellido"
                  label="Nombre completo"
                  variant="outlined"
                  value={
                    datosFormulario.nombre_apellido &&
                    datosFormulario.nombre_apellido.replace(/\b\w/g, (l) =>
                      l.toUpperCase()
                    )
                  }
                  inputProps={{ maxLength: 100 }}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccessibilityNewIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  size={size}
                  style={style}
                  sx={sinAsterisco}
                  focused
                  color="primary"
                  placeholder="ID Sisven HIPERGAS"
                  type="number"
                  name="id_sisven"
                  label="ID SISVEN HIPERGAS"
                  variant="outlined"
                  value={datosFormulario.id_sisven ?? ""}
                  onChange={almacenar}
                    inputProps={{ min: 0 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountBoxIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size={size}
                  style={style}
                  sx={sinAsterisco}
                  focused
                  color="primary"
                  placeholder="ID Sisven AUTOGAS"
                  type="number"
                  name="id_sisven_autogas"
                  label="ID SISVEN AUTOGAS"
                  variant="outlined"
                  value={datosFormulario.id_sisven_autogas ?? ""}
                  onChange={almacenar}
                    inputProps={{ min: 0 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountBoxIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  focused
                  placeholder="DNI"
                  color="primary"
                  style={style}
                  sx={sinAsterisco}
                  type="text"
                  name="dni"
                  label="DNI"
                  variant="outlined"
                  value={datosFormulario.dni ?? ""}
                  onChange={almacenar}
                  onBlur={() => {
                    if (datosFormulario.dni) {
                validarCampo("dni", datosFormulario.dni);
                    }
                  }}
                 inputProps={{ maxLength: 8,min: 0 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircleIcon />
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errorDni)}    // activa rojo si hay error
                  helperText={errorDni} // muestra error o ayuda normal
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  //required 
                  placeholder="Legajo"
                  type="number"
                  name="legajo"
                  label="Legajo"
                  variant="outlined"
                  value={datosFormulario.legajo}
                  onChange={almacenar}
                  inputProps={{ maxLength: 45, min: 0 }} 
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircleIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  sx={sinAsterisco}
                  focused
                  placeholder="Nro licencia"
                  type="text"
                  name="nro_licencia"
                  label="Nro licencia"
                  variant="outlined"
                  value={datosFormulario.nro_licencia ?? ""}
                  onChange={almacenar}
                  inputProps={{ maxLength: 8,min: 0 }}
                       onBlur={() => {
                    if (datosFormulario.nro_licencia) {
             validarCampo("nro_licencia", datosFormulario.nro_licencia);
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PinIcon />
                      </InputAdornment>
                    ),
                  }}
                   error={Boolean(ErrorNroLicencia)}    // activa rojo si hay error
                  helperText={ErrorNroLicencia} // muestra error o ayuda normal
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Vencimiento licencia"
                  name="vencimiento_licencia"
                  label="Vencimiento licencia"
                  variant="outlined"
                  value={moment(datosFormulario.vencimiento_licencia).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InsertInvitationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Exámen cargas"
                  name="examen_carga"
                  label="Examen cargas"
                  variant="outlined"
                  value={moment(datosFormulario.examen_carga).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                />
              </Grid>

              <Grid item xs={6}>
                <FormControl
                  style={style}
                  focused
                  color="primary"
                  required
                  size={size}
                >
                  <InputLabel id="lbl_negocio">Negocio</InputLabel>
                  <Select
                    name="negocio"
                    label="Negocio "
                    value={datosFormulario.negocio}
                    onChange={almacenar}
                  >
                    {uso
                      ? uso.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.valor}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <Autocomplete
                  size={size}
                  options={usuarios || []}
                  getOptionLabel={(option) =>
                    option.nombrepila && option.apellido
                      ? `${option.nombrepila} ${option.apellido} (${option.username})`
                      : option.username || ""
                  }
                  value={
                    usuarios?.find((b) => b.username === datosFormulario.username) || null
                  }
                  onChange={(_, newValue) => {
                    setDatosformulario({
                      ...datosFormulario,
                      username: newValue ? newValue.username : null,
                    });
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.username === value.username
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      focused
                      size={size}
                      color="primary"
                      style={style}
                      label="Usuario del Sistema"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      placeholder="Buscar usuario..."
                      helperText="Vincular con un usuario de la aplicación"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  disabled={!ptosVtaHiper}
                  size={size}
                  focused
                  disableClearable
                  id="puntoventa"
                  noOptionsText={"Punto de Venta NO DISPONIBLE"}
                  options={ptosVtaHiper}
                  autoHighlight
                  getOptionLabel={(ptosVtaHiper) =>
                    ptosVtaHiper.id_punto
                  }
                  onChange={(event, value) =>
                    setDatosformulario({
                      ...datosFormulario,
                      pto_vta_hipergas: value.id_punto,
                    })
                  }
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_punto}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      focused
                      size={size}
                      color="primary"
                      style={style}
                      variant="outlined"
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Punto de Venta HIPERGAS"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  disabled={!ptosVtaAuto}
                  size={size}
                  focused
                  disableClearable
                  id="puntoventa"
                  noOptionsText={"Punto de Venta NO DISPONIBLE"}
                  options={ptosVtaAuto}
                  autoHighlight
                  getOptionLabel={(ptosVtaAuto) =>
                    ptosVtaAuto.id_punto
                  }
                  onChange={(event, value) =>
                    setDatosformulario({
                      ...datosFormulario,
                      pto_vta_autogas: value.id_punto,
                    })
                  }
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id_punto}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      focused
                      size={size}
                      color="primary"
                      style={style}
                      variant="outlined"
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Punto de Venta AUTOGAS"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  size={size}
                  focused
                  placeholder="Teléfono"
                  color="primary"
                  style={style}
                  sx={sinAsterisco}
                  type="text"
                  name="telefono"
                  label="Teléfono"
                  variant="outlined"
                  value={datosFormulario.telefono ?? ""}
                  onChange={almacenar}
                  inputProps={{
                    maxLength: 10,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">{codArg}</InputAdornment>
                    ),
                  }}
                  helperText="Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Grid>

               <Grid item xs={3}>
                <Autocomplete
                  disabled={!sucursales}
                  required
                  disableClearable
                  id="sucursal"
                  style={style}
                  size={size}
                  noOptionsText={"Sucursal INEXISTENTE"}
                  options={sucursales}
                  autoHighlight
                  getOptionLabel={(sucursal) =>
                    sucursal.id + "-" + sucursal.nombre
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  value={sucursalSeleccionada || null}
                  defaultValue={sucursalSeleccionada || null}
                  onChange={(event, value) => {
                    setSucursalSeleccionada(value);
                  }}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      key={option.id}
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      {option.id} - {option.nombre}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                    focused
                      placeholder="Tipee para buscar..."
                      {...params}
                      label="Sucursal"
                      required
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>

<Grid item xs={3}>
  <Autocomplete
    fullWidth
    size="small"
    options={Array.isArray(cajasMercadoPago) ? cajasMercadoPago : []}  // ← Forzar array
    loading={cargandoCajas}
    value={cajaSeleccionada}
    onChange={(event, newValue) => {
      setCajaSeleccionada(newValue);
    }}
    getOptionLabel={(option) => {
      if (option && typeof option === 'object') {
        return `${option.nombre} - (${option.external_id})`;
      }
      return '';
    }}
    isOptionEqualToValue={(option, value) => option?.id === value?.id}
    renderInput={(params) => (
      <TextField
        {...params}
        focused
        size={size}
        style={style}
        label="Caja Mercado Pago"
        placeholder={sucursalSeleccionada ? "Seleccione una caja..." : "Primero seleccione una sucursal"}
        disabled={!sucursalSeleccionada}
      />
    )}
  />
</Grid>
<Grid item xs={12}>
  <Autocomplete
    fullWidth
    size="small"
    options={posnets || []}
    value={posnetSeleccionado}
    onChange={(event, newValue) => {
      setPosnetSeleccionado(newValue);
      
      // VALIDAR CUANDO SE SELECCIONA UNA TERMINAL
      if (newValue && newValue.id) {
        validarCampo("terminal", newValue.id);
      } else {
        setErrorTerminal(""); // Limpiar error si se deselecciona
      }
    }}
    getOptionLabel={(option) => {
      if (option && typeof option === 'object') {
        const label = option.id || '';
        const posId = option.external_pos_id ? `(CAJA: ${option.external_pos_id})` : '';
        return `${label} ${posId}`.trim();
      }
      return '';
    }}
    isOptionEqualToValue={(option, value) => option?.id === value?.id}
    renderInput={(params) => (
      <TextField
        {...params}
        focused
        size={size}
        style={style}
        label="Terminal Point PDV"
        placeholder={sucursalSeleccionada ? "Seleccione terminal PDV..." : "Primero seleccione una sucursal"}
        disabled={!sucursalSeleccionada || posnets.length === 0}
        error={Boolean(errorTerminal)}  // Mostrar error si existe
        helperText={
          errorTerminal || (
            posnets.length === 0 && sucursalSeleccionada 
              ? "No hay terminales en modo PDV" 
              : posnets.length > 0 ? `${posnets.length} terminal(es) en PDV` : ""
          )
        }
      />
    )}
    renderOption={(props, option) => (
      <li {...props}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="body2">
            {option.id} - CAJA: {option.external_pos_id}
          </Typography>
        </Box>
      </li>
    )}
    renderTags={(value, getTagProps) =>
      value.map((option, index) => (
        <Chip
          {...getTagProps({ index })}
          key={option.id}
          label={option.external_pos_id || option.id}
          size="small"
          color="success"
          variant="outlined"
        />
      ))
    }
  />
</Grid>
               
               <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Vencimiento ART"
                  name="fecvto_art"
                  label="Vencimiento ART"
                  variant="outlined"
                  value={moment(datosFormulario.fecvto_art).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InsertInvitationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              
               <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Vencimiento SVO"
                  name="fecvto_svo"
                  label="Vencimiento SVO"
                  variant="outlined"
                  value={moment(datosFormulario.fecvto_svo).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InsertInvitationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              
               {/* <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Vencimiento Remito"
                  name="fecvto_remito"
                  label="Vencimiento  Remito (doc petrolera, referente a la carga)"
                  variant="outlined"
                  value={moment(datosFormulario.fecvto_remito).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InsertInvitationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
             
              <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Vencimiento Protocolo de calidadad"
                  name="fecvto_protcal"
                  label="Vencimiento Protocolo de calidadad"
                  variant="outlined"
                  value={moment(datosFormulario.fecvto_protcal).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InsertInvitationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid> */}

                <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Vencimiento Curso de cargas peligrosa"
                  name="fecvto_cursocp"
                  label="Vencimiento Curso de cargas peligrosa"
                  variant="outlined"
                  value={moment(datosFormulario.fecvto_cursocp).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InsertInvitationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
               
                 <Grid item xs={6}>
                <TextField
                  size={size}
                  style={style}
                  focused
                  type="date"
                  placeholder="Vencimiento Psicofisico"
                  name="fecvto_psicof"
                  label="Vencimiento Psicofisico"
                  variant="outlined"
                  value={moment(datosFormulario.fecvto_psicof).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <InsertInvitationIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>



            </Grid>
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                {/*Volver original*/}
               {origen === "vehiculos"?"Volver a vehiculos":"Volver"}
              </Button>

              <Button
                disabled={disBtn}
                variant="contained"
                type="submit"
                color="success"
              >
                Guardar Chofer
              </Button>
            </Grid>
          </Box>
        </form>
        <br/>
        <br/>
      </Container>
      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={() => {
            handleClose();
          }}
          severity={notificacion.severity}
          duracion={1000}
        />
      ) : null}
    </div>
  );
}

export default Addchofer;
